export const GET_HAZARD_REPROTS_BY_LOCATION = "GET_HAZARD_REPROTS_BY_LOCATION";
export const GET_HAZARD_REPROTS_BY_LOCATION_SUCCESS = "GET_HAZARD_REPROTS_BY_LOCATION_SUCCESS";
export const GET_HAZARD_REPROTS_BY_LOCATION_FAIL = "GET_HAZARD_REPROTS_BY_LOCATION_FAIL";

export const SUBMIT_REVIEWD_HAZARD_REPORT = "SUBMIT_REVIEWD_HAZARD_REPORT";
export const SUBMIT_REVIEWD_HAZARD_REPORT_SUCCESS = "SUBMIT_REVIEWD_HAZARD_REPORT_SUCCESS";
export const SUBMIT_REVIEWD_HAZARD_REPORT_FAIL = "SUBMIT_REVIEWD_HAZARD_REPORT_FAIL";

export const GET_HAZARD_REPORT = "GET_HAZARD_REPORT";
export const GET_HAZARD_REPORT_SUCCESS = "GET_HAZARD_REPORT_SUCCESS";
export const GET_HAZARD_REPORT_FAIL = "GET_HAZARD_REPORT_FAIL";

export const SAVE_HAZARD_EMAIL = "SAVE_HAZARD_EMAIL";
export const SAVE_HAZARD_EMAIL_SUCCESS = "SAVE_HAZARD_EMAIL_SUCCESS";
export const SAVE_HAZARD_EMAIL_FAIL = "SAVE_HAZARD_EMAIL_FAIL";
